export const useGoogleFilters = (
  mapFilter: Ref<Record<string, FilterQueryValue>>,
  categories: Ref<Array<AssetCategory>>,
  cities: Ref<Array<string>>,
) => {
  const authStore = useAuthStore()
  const supplierStore = useSupplierStore()

  const cityFilters = useLocalStorage<Array<string>>(`map:${authStore.currentOrganization}:cities`, [])
  const assetCategories = useLocalStorage<Array<string>>(`map:${authStore.currentOrganization}:asset-categories`, [])

  watchEffect(() => {
    if (supplierStore.isLoggedInOnSupplier) {
      mapFilter.value = {}
      return
    }

    const categoryFilter: Record<string, FilterQueryValue> = {}
    const cityFilter: Record<string, FilterQueryValue> = {}

    if (assetCategories.value.length && categories.value.length !== assetCategories.value.length) {
      categoryFilter["category._id"] = {
        $in: assetCategories.value,
      }
    }
    if (cityFilters.value.length && cityFilters.value.length !== cities.value.length) {
      cityFilter["location.city"] = {
        $in: cityFilters.value,
      }
    }

    mapFilter.value = {
      ...categoryFilter,
      ...cityFilter,
    }
  })

  return {
    cityFilters,
    assetCategories,
  }
}
